import Page from "webPage/Page";
import {handleTestimonials} from "util/handleTestimonials";

Page.register('page-template-about-us', () => {
    handleTestimonials();
});
